import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  orderBy,
  query,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";

interface FeedbackEntry {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  feedback: string;
  submittedAt: Timestamp | null;
}

const FeedbackAdmin: React.FC = () => {
  const [entries, setEntries] = useState<FeedbackEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetch = async () => {
      try {
        const q = query(
          collection(db, "feedback"),
          orderBy("submittedAt", "desc")
        );
        const snap = await getDocs(q);
        setEntries(
          snap.docs.map((doc) => ({ id: doc.id, ...doc.data() } as FeedbackEntry))
        );
      } catch (e) {
        setError("Failed to load feedback. Check Firestore permissions.");
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  const formatDate = (ts: Timestamp | null) => {
    if (!ts) return "—";
    return ts.toDate().toLocaleString();
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <a href="/" className="admin-back">← Back to site</a>
        <h1>Feedback Submissions</h1>
        <p className="admin-count">
          {loading ? "" : `${entries.length} submission${entries.length !== 1 ? "s" : ""}`}
        </p>
      </div>

      <div className="admin-content">
        {loading && <p className="admin-loading">Loading…</p>}
        {error && <p className="admin-error">{error}</p>}
        {!loading && !error && entries.length === 0 && (
          <p className="admin-empty">No feedback submitted yet.</p>
        )}
        {entries.map((entry) => (
          <div key={entry.id} className="admin-card">
            <div className="admin-card__meta">
              <span className="admin-card__name">
                {entry.firstName} {entry.lastName}
              </span>
              <span className="admin-card__email">{entry.email}</span>
              <span className="admin-card__date">{formatDate(entry.submittedAt)}</span>
            </div>
            <p className="admin-card__feedback">{entry.feedback}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeedbackAdmin;
